import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import { StoreNotesCardProps } from '../types/StoreNotesCardProps';
import '../../../common/action-required-card/components/ActionRequiredCard.scss';

export default function StoreNotesCard(props: StoreNotesCardProps) {

    const navigate = useNavigate();
    const noteCount = props.statData.find(x => x.statID === props.statID)?.total ?? 0;

    return (
        <div className='ar-button dx-card read-notes'>
            <div className='ar-text ar-text-multiline'>Notes</div>
            <div className='ar-total'>
                <span>{noteCount}</span>
            </div>
            <div className='button-replacement'>
            </div>
            <Button onClick={() => navigate(props.url)}>
                Read Notes
            </Button>
        </div>
    )
} 
